/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import { FormInput, FormCheckbox, Text } from '@getgrover/ui';
import React from 'react';
import { Translator } from 'ggApp/modules/translator/components';

const FormComponentFieldWrap = ({
    id,
    label,
    type,
    name,
    onChange,
    onFocus,
    onBlur,
    mask,
    maskChar,
    tag,
    styleMixin,
    styleModifiers,
    input,
    meta,
}) => {
    const { touched, error } = meta;

    switch (type) {
        case 'text': {
            return (
                <FormInput
                    error={touched && error && <Translator tk={error} />}
                    label={label}
                    input={{
                        id,
                        value: input.value,
                        type,
                        name,
                        mask,
                        maskChar,
                        onChange: (e) => {
                            input.onChange(e);
                            onChange && onChange(e);
                        },
                        onFocus: (e) => {
                            input.onFocus(e);
                            onFocus && onFocus(e);
                        },
                        onBlur: (e) => {
                            input.onBlur(e);
                            onBlur && onBlur(e);
                        },
                    }}
                />
            );
        }

        case 'checkbox': {
            return (
                <FormCheckbox
                    error={touched && error && <Translator tk={error} />}
                    input={{
                        id,
                        value: input.value,
                        type,
                        name,
                        onChange: (e) => {
                            input.onChange(e);
                            onChange && onChange(e);
                        },
                    }}
                >
                    <Text tag={tag} styleMixin={styleMixin} styleModifiers={styleModifiers}>
                        {label}
                    </Text>
                </FormCheckbox>
            );
        }

        default:
            return null;
    }
};

export default FormComponentFieldWrap;
